import BaseModal, { ModalHeader } from 'components/Modals';
import ActionButtons from 'pages/Common/bulkactions/ActionButtons';
import { useTranslation } from 'react-i18next';
import { StyledModalBody } from './styles';

export const PerformSingleActionModal = ({
  onHide,
  isMobile,
  onSelect,
  fullName,
  performActionOptions,
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <BaseModal size="medium" onHide={onHide} {...props}>
      <ModalHeader onClickClose={onHide}>
        {`${t('Perform Action on')} ${fullName}`}
      </ModalHeader>
      <StyledModalBody>
        <ActionButtons
          mobile={isMobile}
          onSelect={onSelect}
          performActionOptions={performActionOptions}
        />
      </StyledModalBody>
    </BaseModal>
  );
};
